<template>
    <div
        class="max-w-2xl flex flex-row flex-wrap justify-start items-start"
        v-if="state.user.contactinfo"
    >
        <avatar-bubble
            class="h-14 w-14 mt-1 mb-7"
            :user="state.user"
            :isEditable="true"
            @emitDelete="
                state.newProfileImage = null;
                state.user.avatar = null;
            "
            @change="(file) => (state.newProfileImage = file)"
        />
        <div class="w-full" />
        <div class="xs:max-w-64 w-full flex flex-row flex-wrap">
            <input-select
                :name="'salutation'"
                :id="'salutation'"
                :options="['Herr', 'Frau', 'Divers']"
                :activeItems="
                    state.user.contactinfo.salutation
                        ? [state.user.contactinfo.salutation]
                        : []
                "
                :label="'Anrede'"
                :labelClass="'text-grey bg-white'"
                background="bg-white"
                class="w-full xs:w-50-8 xs:mr-4 mb-4"
                @changeItem="
                    (newItem) => {
                        if (newItem == state.user.contactinfo.salutation) {
                            state.user.contactinfo.salutation = null;
                        } else {
                            state.user.contactinfo.salutation = newItem;
                        }
                    }
                "
            />
            <input-text
                :name="'degree_title'"
                :id="'degree_title'"
                v-model="state.user.contactinfo.degree_title"
                :label="'Titel'"
                :labelClass="'bg-white'"
                class="w-full xs:w-50-8 mb-4"
            />
        </div>
        <div class="w-full" />
        <input-text
            :name="'first_name'"
            :id="'first_name'"
            v-model="state.user.first_name"
            :label="'Vorname'"
            :labelClass="'bg-white'"
            class="mb-4 xs:mr-4 w-full xs:max-w-64 xs:w-50-8"
        />

        <input-text
            :name="'last_name'"
            :id="'last_name'"
            v-model="state.user.last_name"
            :label="'Nachname'"
            :labelClass="'bg-white'"
            class="mb-4 w-full xs:max-w-64 xs:w-50-8"
        />
        <div class="w-full" />
        <input-text
            :name="'birthday'"
            :id="'birthday'"
            v-model="state.user.contactinfo.birthday"
            :label="'Geburtsdatum'"
            :labelClass="'bg-white'"
            :type="'date'"
            class="mb-4 xs:mr-4 w-full xs:max-w-64 xs:w-50-8"
        />
        <input-text
            :name="'street'"
            :id="'street'"
            v-model="state.user.contactinfo.street"
            :label="'Str. & Hausnr.'"
            :labelClass="'bg-white'"
            class="mb-4 w-full xs:max-w-64 xs:w-50-8"
        />
        <div class="w-full" />
        <div
            class="xs:max-w-64 xs:w-50-8 w-full xs:mr-4 flex flex-row flex-wrap"
        >
            <input-text
                :name="'zipcode'"
                :id="'zipcode'"
                v-model="state.user.contactinfo.zipcode"
                :label="'PLZ'"
                :labelClass="'bg-white'"
                class="w-full xs:w-50-8 xs:mr-4 mb-4"
            />
            <input-text
                :name="'city'"
                :id="'city'"
                v-model="state.user.contactinfo.city"
                :label="'Stadt'"
                :labelClass="'bg-white'"
                class="w-full xs:w-50-8 mb-4"
            />
        </div>
        <input-text
            :name="'country'"
            :id="'country'"
            v-model="state.user.contactinfo.country"
            :label="'Land'"
            :labelClass="'bg-white'"
            class="mb-4 w-full xs:max-w-64 xs:w-50-8"
        />
        <div class="w-full" />
        <input-text
            :name="'phone'"
            :id="'phone'"
            v-model="state.user.contactinfo.phone"
            :label="'Telefon'"
            :labelClass="'bg-white'"
            class="mb-4 xs:mr-4 w-full xs:max-w-64 xs:w-50-8"
        />

        <input-text
            :name="'mobile'"
            :id="'mobile'"
            v-model="state.user.contactinfo.mobile"
            :label="'Handy'"
            :labelClass="'bg-white'"
            class="mb-4 w-full xs:max-w-64 xs:w-50-8"
        />
        <div class="w-full" />
        <input-text
            :name="'facebook_link'"
            :id="'facebook_link'"
            v-model="state.user.contactinfo.facebook_link"
            :label="'Facebook'"
            :labelClass="'bg-white'"
            class="mb-4 xs:mr-4 w-full xs:max-w-64 xs:w-50-8"
        >
            <template #icon><linked-icon :fillClass="'fill-grey'" /></template
        ></input-text>

        <input-text
            :name="'instagram_link'"
            :id="'instagram_link'"
            v-model="state.user.contactinfo.instagram_link"
            :label="'Instagram'"
            :labelClass="'bg-white'"
            class="mb-4 w-full xs:max-w-64 xs:w-50-8"
        >
            <template #icon><linked-icon :fillClass="'fill-grey'" /></template
        ></input-text>

        <div class="w-full" />
        <div class="w-full flex flex-row justify-end" style="max-width: 530px">
            <custom-button
                @click="emitUser"
                class="w-full xs:w-48 h-11"
                :text="'Speichern'"
                :bgColor="'bg-primary'"
                :textColor="'text-white'"
                :id="'save-button'"
            />
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, reactive } from "@vue/runtime-core";
import { cloneData } from "../../common/dataHelper";
import AvatarBubble from "../../components/helper/AvatarBubble.vue";
import CustomButton from "../../components/input/CustomButton.vue";
import InputSelect from "../../components/input/InputSelect.vue";
import InputText from "../../components/input/InputText.vue";

export default defineComponent({
    name: "ProfileForm",
    components: { AvatarBubble, InputText, CustomButton, InputSelect },
    emits: ["change"],
    props: { user: { required: true } },
    setup(props, ctx) {
        const state = reactive({ user: {}, newProfileImage: null });

        function emitUser() {
            const uploadUser = cloneData(state.user);
            if (state.newProfileImage) {
                uploadUser.avatar = state.newProfileImage;
            }
            ctx.emit("change", uploadUser);
        }

        onMounted(() => {
            state.user = cloneData(props.user);
            if (!state.user.contactinfo) {
                state.user.contactinfo = {};
            }
        });
        return { state, emitUser };
    },
});
</script>
